module.exports = __webpack_public_path__ + "railsPostit.svg?f1da0049414da973ecd8110c04b94a8b";